{
  "Accessibility Menu": "Menu de Acessibilidade",
  "Reset settings": "Redefinir configurações",
  "Close": "Fechar",
  "Content Adjustments": "Ajustes de Conteúdo",
  "Adjust Font Size": "Ajustar Tamanho da Fonte",
  "Highlight Title": "Destacar Título",
  "Highlight Links": "Destacar Links",
  "Readable Font": "Fonte Legível",
  "Color Adjustments": "Ajustes de Cor",
  "Dark Contrast": "Contraste Escuro",
  "Light Contrast": "Contraste Claro",
  "High Contrast": "Alto Contraste",
  "High Saturation": "Saturação Alta",
  "Low Saturation": "Saturação Baixa",
  "Monochrome": "Monocromático",
  "Contrast": "Contraste",
  "Invert Colors": "Inverter cores",
  "Tools": "Ferramentas",
  "Reading Guide": "Guia de Leitura",
  "Stop Animations": "Parar Animações",
  "Big Cursor": "Cursor Grande",
  "Increase Font Size": "Aumentar Tamanho da Fonte",
  "Decrease Font Size": "Diminuir Tamanho da Fonte",
  "Letter Spacing": "Espaçamento entre Letras",
  "Line Height": "Altura da Linha",
  "Font Weight": "Espessura da Fonte",
  "Dyslexia Font": "Fonte para Dislexia",
  "Language": "Idioma",
  "Open Accessibility Menu": "Abrir menu de acessibilidade",
  "Widget Settings": "Configurações do widget",
  "Widget Position": "Posição do widget",
  "Top Left": "Superior esquerdo",
  "Top Center": "Superior central",
  "Top Right": "Superior direito",
  "Center Left": "Centro esquerdo",
  "Center Right": "Centro direito",
  "Bottom Left": "Inferior esquerdo",
  "Bottom Center": "Inferior central",
  "Bottom Right": "Inferior direito",
  "Screen Reader": "Leitor de tela",
  "Voice Navigation": "Navegação por voz",
  "Custom Color": "Cor personalizada",
  "Change the site's colors": "Alterar as cores do site",
  "Backgrounds": "Planos de fundo",
  "Headings": "Cabeçalhos",
  "Contents": "Conteúdos",
  "Reset colors": "Redefinir cores",
  "Image Desaturation": "Dessaturação de imagem",
  "Search languages": "Pesquisar idiomas",
  "No languages found": "Nenhum idioma encontrado",
  "Accessibility Profiles": "Perfis de acessibilidade",
  "Motor Impaired": "Deficiência motora",
  "Big cursor, voice navigation, and no animations.": "Cursor grande, navegação por voz e sem animações.",
  "Blind": "Cegueira",
  "Screen reader helpers with higher contrast.": "Auxiliares de leitor de tela com contraste maior.",
  "Color Blind": "Daltonismo",
  "High contrast palette with desaturated media.": "Paleta de alto contraste com mídias dessaturadas.",
  "Dyslexia": "Dislexia",
  "Friendly font, extra spacing, stronger weight.": "Fonte amigável, espaçamento extra e maior espessura.",
  "Low vision": "Baixa visão",
  "Dark contrast and 130% magnification.": "Contraste escuro e ampliação de 130 %.",
  "Cognitive & Learning": "Cognitivo e aprendizado",
  "Highlights key sections and enables voice help.": "Destaca seções-chave e ativa o auxílio por voz.",
  "Seizure & Epileptic": "Convulsões e epilepsia",
  "Stops animations and desaturates imagery.": "Interrompe animações e dessatura imagens.",
  "ADHD": "TDAH",
  "Reading guide, highlighted links, calmer palette.": "Guia de leitura, links destacados e paleta mais calma.",
  "Widget Size": "Tamanho do widget",
  "Default": "Padrão",
  "Medium": "Médio",
  "Small": "Pequeno",
  "Color Blindness": "Daltonismo",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Acromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simula e auxilia usuários com deficiências na visão das cores."
}
